/**
 * Section & Table Selectors
 * Selectors for accessing sections and tables state
 */

import { createSelector } from '@reduxjs/toolkit';
import { SectionsAndTablesState } from '../../types/section';

interface RootState {
  sections: SectionsAndTablesState;
}

const selectSectionState = (state: RootState): SectionsAndTablesState =>
  state.sections;

export const selectAllSections = createSelector(
  [selectSectionState],
  (sectionsState) => sectionsState.sections,
);

export const selectVisibleSections = createSelector(
  [selectAllSections],
  (sections) => sections.filter((s) => !s.is_hidden),
);

export const selectAllTables = createSelector(
  [selectSectionState],
  (sectionsState) => sectionsState.tables,
);

export const selectVisibleTables = createSelector([selectAllTables], (tables) =>
  tables.filter((t) => !t.is_hidden),
);

export const selectTablesBySectionId = (sectionId: number) =>
  createSelector([selectAllTables], (tables) =>
    tables.filter((t) => t.section_id === sectionId),
  );

export const selectSectionById = (sectionId: number) =>
  createSelector([selectAllSections], (sections) =>
    sections.find((s) => s.id === sectionId),
  );

export const selectSectionsLoading = createSelector(
  [selectSectionState],
  (sectionsState) => sectionsState.isLoading,
);

export const selectSectionsError = createSelector(
  [selectSectionState],
  (sectionsState) => sectionsState.error,
);

export const selectSectionCount = createSelector(
  [selectAllSections],
  (sections) => sections.length,
);

export const selectTableCount = createSelector(
  [selectAllTables],
  (tables) => tables.length,
);

export const selectLocalOpenDineTableIds = createSelector(
  [selectSectionState],
  (sectionsState) => sectionsState.localOpenDineTableIds,
);
